import { AfterViewInit, Component, Input, OnInit, Optional } from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
  selector: 'app-table-column',
  templateUrl: './table-column.component.html',
  styleUrls: ['./table-column.component.css']
})
export class TableColumnComponent {
  @Input() size = "1fr";
  @Input() span = 1;
  @Input() align: "right" | "left" = "left"
  @Input() truncate = false;
}